import React from 'react';
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';
import { TimeReferenceType } from '../constants';

const TimeReferenceDropDown = ({ ...props }) => {
  const text = useTextResources();
  const types = [
    {
      Id: TimeReferenceType.BeforeArrivalDate,
      Name: text('BeforeArrivalDate'),
    },
    {
      Id: TimeReferenceType.AfterReservationDate,
      Name: text('AfterArrivalDate'),
    },
  ];
  return (
    <DropDown
      search={false}
      data={types}
      textField='Name'
      valueField='Id'
      {...props}
    />
  );
};

export default TimeReferenceDropDown;
